import React from "react";
import { Head, Phrase, MessageShower } from "../../components";
import "./dashboard.css";

const Dashboard = () => {
  return (
    <>
      <div className="dashboard-g">
        <Head title="Bienvenido a SPC" />
        <Phrase />
        <MessageShower />
      </div>
    </>
  );
};

export default Dashboard;
